let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("covqK"), load("8Y1Y3")]).then(() => parcelRequire('gOItI'));